<template>
  <div ref="hero" class="hero">
    <slot
      :toggleLoop="toggleLoop"
    />
  </div>
</template>

<script>
export default {
  methods: {
    toggleLoop() {
      const hero = this.$refs.hero;
      const loop = hero.querySelector('.hero__loop');
      const playBtn = hero.querySelector('.hero__play-btn');

      if (loop.paused) {
        loop.play();
        playBtn.classList.remove('paused');
      } else {
        loop.pause();
        playBtn.classList.add('paused');
      }
    }
  }
}
</script>